export const NOT_ALLOW_EDIT_OWN_ACCOUNT_MESSAGE =
  'You are not allowed to modify your own account, please connect with another administrator for your client to complete the update process.';

export const isOwnInfo = ({ rowData, customerData }) =>
  rowData?.userId === customerData?.customerId;
